import React, { useState } from 'react';
import { useIntl, useParams, history } from 'umi';
import { Layout } from 'tea-component';
import Tabs from '@intelligence/components/NewIconTabs';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';
import SteamTab from './page/steam';
import EpicGamesTab from './page/epicgames';
import { getValidActiveId } from '@/pages/intelligence/utils/commonUtils';
import SvgIcon from '@/pages/home/components/SvgIcon';
import '@/pages/intelligence/assets/scss/StoreRanks/PCGlobal/index.scss';
import './index.scss';
import type { IBaseProps } from '@/pages/intelligence/types/common';

import './index.scss';

const { Content } = Layout;

const DEFAULT_TAB = 'steam';

type IPCStoreRankTopTabsPageProps = IBaseProps;

const PCStoreRankTopTabsPage: React.FC<IPCStoreRankTopTabsPageProps> = (props) => {
  const {} = props;
  const { tab: pathActiveId } = useParams<any>();

  const { formatMessage } = useIntl();

  const tabs = [
    {
      id: 'steam',
      label: (
        <div className="dbi-tab-item">
          <SvgIcon className="dbi-tab-item-icon" type="awesome-steam" />
          <span className="dbi-tab-item-text">
            {formatMessage({ id: 'dbi_store_rank_pc_steam' })}
          </span>
        </div>
      ),
      component: SteamTab,
    },
    {
      id: 'epic',
      label: (
        <div className="dbi-tab-item">
          <SvgIcon className="dbi-tab-item-icon" type="Epic" />
          <span className="dbi-tab-item-text">
            {formatMessage({ id: 'dbi_store_rank_pc_epic_games' })}
          </span>
        </div>
      ),
      component: EpicGamesTab,
    },
  ];

  const initialActiveId = getValidActiveId(pathActiveId, { tabs, defaultActiveId: DEFAULT_TAB });
  const [activeId, setActiveId] = useState(initialActiveId);

  const handleActive = (tab: { id: string }) => {
    const activeIdTmp = tab?.id || DEFAULT_TAB;
    setActiveId(activeIdTmp);
    history.replace(`/intelligence/storeRanks/PCGlobal/${activeIdTmp}`);
  };

  return (
    <Content className="dbi-page dbi-storeranks--pc dbi-pc-global">
      <Content.Header
        className="dbi-header contentHead-normal"
        title={formatMessage({ id: 'dbi_store_rank_pc_pc_global' })}
      >
        <div className="header-tab">
          <Tabs
            ceiling
            newMarkIdsMappingKey="StoreRanksPCGlobal"
            animated={false}
            tabs={tabs}
            activeId={activeId}
            onActive={handleActive}
          />
        </div>
      </Content.Header>

      <Content.Body full>
        <MarqueeBanner />
        {tabs.map((tab) => (
          <div key={tab?.id}>{tab?.id === activeId && tab?.component && <tab.component />}</div>
        ))}
      </Content.Body>
    </Content>
  );
};

export default PCStoreRankTopTabsPage;
